import { useReactiveVar } from "@apollo/client"
import { uncompletedPurchases } from "./reactiveVars"

/** Outstanding payments returns payments that are not yet completed.
 *
 * These are typically Vipps-payments that the user somehow was not redirected correctly to.
 *
 * There are a combination of two sources:
 * - LocalStorage is populated on the device of which the payment is started, before redirecting to vipps.
 * - Server also keeps track of these items
 *
 * The result is combined into unique entries.
 * */
export const useOutstandingPayments = () => {
  const purchases = useReactiveVar(uncompletedPurchases.var)
  /* TODO: poll for orders / merge with order polling in general. */
  /*const r = useQuery(OutstandingPaymentsDocument, {
    pollInterval: pollInterval(5000),
    onCompleted: (d) => {
      for (const n of d.outstandingPayments) {
        uncompletedPurchases.remove(n.id)
      }
    },
    skip: enableNewVippsCheckout
  })
  const outstanding = r.data?.outstandingPayments?.map((d) => {
    return {
      productID: d.productID,
      paymentMethod: PaymentMethod.Vipps,
      paymentID: d.id,
      date: d.lastState?.time,
      productText: d.product?.name || "",
      // Payments for vipps are recorded as ints with decimals, divide by 100 to get the value in NOK
      amount: (d.lastState?.amount || 0) / 100,
      orderID: d.orderID,
      operation: d.lastState?.operation,
      source: "server",
    } as IncompletePurchase & { operation?: PaymentOperation }
  })

  const first: IncompletePurchase | null = outstanding?.length
    ? outstanding[0]
    : Object.values(purchases || {})[0] || null
*/
  const first = Object.values(purchases || {})[0] || null
  return {
    firstOutstanding: first,
    purchases,
    count: /*(outstanding?.length || 0) +*/ Object.keys(purchases || {}).length,
    outstanding: undefined,
  /*  outstanding,
    ...r,*/

    ...uncompletedPurchases,
  }
}
